<template>
<v-layout column>
  <h1>Boxes</h1>

<v-card v-for="(subscription_product, i) in subscriptionProducts.assigned" :key="'subscription_product-'+i" class="mt-3 elevation-2">
    <v-toolbar dense dark :class="{'primary': !isDark, 'grey darken-4': isDark}">
        <v-toolbar-title style="font-weight:300;">{{subscription_product.product.title}}</v-toolbar-title>
    </v-toolbar>

    <v-data-table
      :headers="subscription_product_headers" 
      :items="subscription_product.variants" 
      :loading="ui.loading" 
      :hide-actions="subscription_product.variants.length <= 10"
      class="elevation-0"
      item-key="sku"
    >
        <v-toolbar flat color="white">
            <v-toolbar-title>{{subscription_product.title}}</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-progress-linear slot="progress" :color="isDark ? 'white' :'blue'" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
            <tr class="pointer" :class="{'box-card-toolbar': props.expanded}">
                <td @click="props.expanded = !props.expanded" class="font-weight-bold">{{ props.item.title }}</td>
                <td @click="props.expanded = !props.expanded">{{ props.item.sku }}</td>
                <td @click="props.expanded = !props.expanded">{{ props.item.boxes.length }}</td>
                <td @click="props.expanded = !props.expanded">{{ props.item.box_sets.length }}</td>
                <td v-if="ui.tab === 0">
                  <v-tooltip left>
                  <v-btn slot="activator" icon raised small class="text-xs-center mt-2" :class="{'primary': !isDark, 'grey darken-4': isDark}" @click.native="createBox(subscription_product, i, props.item)">
                      <v-icon>add</v-icon>
                  </v-btn>
                  <span>Add Box</span>
                  </v-tooltip>
                </td>
                <td v-else>
                  <v-tooltip left>
                  <v-btn slot="activator" icon raised small class="text-xs-center mt-2" :class="{'primary': !isDark, 'grey darken-4': isDark}" @click.native="createBoxSet(props.item)">
                      <v-icon>add</v-icon>
                  </v-btn>
                  <span>Add Box Set</span>
                  </v-tooltip>
                </td>
            </tr>
        </template>
        
        <template slot="expand" slot-scope="props">
          <v-layout column :class="{'box-card-toolbar': props.expanded}">
            <v-flex xs12>
 
            <v-tabs
              v-model="ui.tab"
              :dark="isDark"
              :light="!isDark"
              grow
              slider-color="transparent"
            >
            <v-tab ripple :style="{'background': isDark && ui.tab === 1 ? '#303030!important' : !isDark && ui.tab === 1 ? '#E0E0E0!important' : 'transparent'}">
              Boxes
            </v-tab>
            <v-tab ripple :style="{'background': isDark && ui.tab === 0 ? '#303030!important' : !isDark && ui.tab === 0 ? '#E0E0E0!important' : 'transparent'}">
              Sets
            </v-tab>

            <v-tab-item>
              <v-card flat>
              
              <v-data-table
                :headers="subscription_product_variant_headers" 
                :items.sync="props.item.boxes" 
                :loading="ui.loading" 
                :hide-actions="props.item.boxes.length <= 5" 
                class="elevation-0"
                no-data-text="This subscription product variant does not have any boxes yet."
              >
              <template slot="items" slot-scope="boxes">
                <tr  @click="boxes.expanded = !boxes.expanded" class="pointer" :class="{'box-card-toolbar': boxes.expanded}">
                    <td class="font-weight-bold">{{ boxes.item.description }}</td>
                    <td>{{ calculateTotalItems(boxes.item.line_items) }}</td>
                    <td>{{ calculateWeight(boxes.item.line_items) }}oz</td>
                    <td>${{ calculateWorth(boxes.item.line_items) }}</td>
                    <td class="text-xs-center">
                        <v-icon :class="{'box-card-icon': boxes.expanded}" v-if="boxes.item.default">check</v-icon>
                    </td>
                </tr>
              </template>

              <template slot="expand" slot-scope="box">

                    <v-toolbar dense class="transparent">
                        <v-btn icon @click="box.expanded = !box.expanded">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title></v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-tooltip left>
                            <v-btn slot="activator" icon small class="no-hover" @click="deleteBox(box.item, props.item)">
                                <v-icon style="position:relative;margin-top:6px;">delete</v-icon>
                            </v-btn>
                            <span>Delete Box</span>
                            </v-tooltip>
                        </v-toolbar-items>
                    </v-toolbar>

                      <v-container fluid class="pa-0 mt-2">
                      <v-layout column>
                          <v-flex xs12 class="pa-0">
                              <v-card flat class="pa-0">

                                      <v-container fluid grid-list-md>
                                          <v-layout row wrap>
                                              <v-flex xs12>
                                                  <v-text-field v-model="box.item.description" @blur="saveBox(box.item)" :counter="200" label="Description" required></v-text-field>
                                              </v-flex>
                                              <v-flex xs12>
                                                  <v-checkbox 
                                                  @change="updateBoxDefault(subscription_product, box.item)" 
                                                  v-model="box.item.default"
                                                  :disabled="box.item.default"
                                                  label="Is this the default box for this subscription product?"
                                                  >
                                                  </v-checkbox>
                                              </v-flex>
                                          </v-layout>

                                          <v-layout row wrap>
                                              <v-flex xs12>
                                                <v-card class="elevation-4">
                                                <v-card-title>
                                                <h2>Box Items</h2>
                                                </v-card-title>
                                                  <v-data-table
                                                    :headers="box_headers"
                                                    :items.sync="box.item.line_items"
                                                    hide-actions
                                                  >
                                                    <template slot="items" slot-scope="props">
                                                        <td>{{ props.item.title }}</td>
                                                        <td>{{ props.item.sku }}</td>
                                                        <td>{{ props.item.weight }}oz</td>
                                                        <td>${{ props.item.price }}</td>
                                                        <td>{{ getVariantInventory(props.item.product_id, props.item.sku) }}</td>
                                                        <td class="text-xs-center">
                                                          <v-btn icon small class="no-hover" @click="updateItemQuantity(subscription_product, box.item, props.item, 'add')">
                                                              <v-icon>add</v-icon>
                                                          </v-btn>
                                                          {{props.item.quantity}}
                                                          <v-btn icon small class="no-hover" @click="updateItemQuantity(subscription_product, box.item, props.item, 'remove')">
                                                              <v-icon>remove</v-icon>
                                                          </v-btn>
                                                        </td>
                                                        <td>
                                                          <v-btn icon @click="removeItemFromBox(subscription_product, box.item, props.item)">
                                                            <v-icon>delete</v-icon>
                                                          </v-btn>
                                                        </td>
                                                    </template>
                                                  </v-data-table>
                                                  </v-card>
                                              </v-flex>

                                              <v-flex xs12>
                                                <v-card class="elevation-4">
                                                <v-card-title>
                                                <h2>Products</h2>
                                                <v-spacer></v-spacer>
                                                <v-text-field
                                                  v-model="productSearch"
                                                  append-icon="search"
                                                  label="Search"
                                                  single-line
                                                  hide-details
                                                ></v-text-field>
                                                </v-card-title>
                                                  <v-data-table
                                                    :headers="product_headers"
                                                    :items="products"
                                                    :search="productSearch"
                                                    :hide-actions="products.length <= 5"
                                                  >
                                                    <template slot="items" slot-scope="props">
                                                      <tr @click="props.expanded = !props.expanded" class="pointer" :class="{'box-card-toolbar': props.expanded}"> 
                                                      <td>
                                                          <v-btn icon>
                                                              <v-icon :class="{'box-card-icon': props.expanded}">expand_more</v-icon>
                                                          </v-btn>
                                                        </td>
                                                        <td>{{ props.item.title }}</td>
                                                        <td>{{ props.item.product_type }}</td>
                                                        <td>{{ props.item.variants.length }}</td>
                                                      </tr>
                                                    </template>
                                                    <template slot="expand" slot-scope="props">
                                                      <v-flex xs12 sm11 offset-sm1 class="transparent">
                                                      <v-data-table
                                                        :headers="variant_headers"
                                                        :items="props.item.variants"
                                                        hide-actions
                                                        class="elevation-10 variant-table"
                                                      >
                                                      <template slot="items" slot-scope="props">
                                                        <td>{{ props.item.title }}</td>
                                                        <td>{{ props.item.sku }}</td>
                                                        <td>{{ props.item.weight }}oz</td>
                                                        <td>{{ getVariantInventory(props.item.product_id, props.item.sku) }}</td>
                                                        <td>${{ props.item.price }}</td>
                                                        <td>
                                                          <v-btn icon>
                                                            <v-icon @click="addItemToBox(subscription_product, box.item, props.item)">add</v-icon>
                                                          </v-btn>
                                                        </td>
                                                      </template>
                                                      </v-data-table>
                                                      </v-flex>
                                                    </template>
                                                  </v-data-table>
                                                  </v-card>
                                              </v-flex>
                                          </v-layout>
                                      </v-container>
                         
                              </v-card>
                          </v-flex>
                      </v-layout>
                      </v-container>
              </template>
              </v-data-table>

              </v-card>
              </v-tab-item>

              <v-tab-item>
   
                <v-card flat>
                  <v-card-text class="pa-0">

              <v-data-table
                :headers="box_set_headers" 
                :items.sync="props.item.box_sets" 
                :loading="ui.loading" 
                class="elevation-0 pa-0"
                hide-actions
                no-data-text="This subscription product variant does not have any box sets yet."
              >
              <template slot="items" slot-scope="sets">
                <tr @click="sets.expanded = !sets.expanded" class="pointer" :class="{'box-card-toolbar': sets.expanded}">
                    <td class="font-weight-bold">{{ sets.item.description }}</td>
                    <td>{{ Object.keys(sets.item.months).length }}</td>
                    <td class="text-xs-center">
                        <v-icon :class="{'box-card-icon': sets.expanded}" v-if="sets.item.default">check</v-icon>
                    </td>
                </tr>
              </template>
              <template slot="expand" slot-scope="set">
                  <v-toolbar dense class="transparent">
                      <v-btn icon @click="set.expanded = !set.expanded">
                          <v-icon>close</v-icon>
                      </v-btn>
                      <v-toolbar-title></v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-toolbar-items>
                          <v-tooltip left>
                          <v-btn slot="activator" icon small class="no-hover" @click="deleteBoxSet(set.item)">
                              <v-icon style="position:relative;margin-top:6px;">delete</v-icon>
                          </v-btn>
                          <span>Delete Box Set</span>
                          </v-tooltip>
                      </v-toolbar-items>
                  </v-toolbar>

                  <v-container grid-list-xl fluid>
                  <v-layout row wrap>
                  <v-flex xs12 class="pb-0">
                      <v-text-field 
                        v-model="set.item.description" 
                        :counter="200" 
                        @blur="saveBoxSet(set.item)"
                        label="Box Set Description" 
                        required
                      >
                      </v-text-field>
                      <v-checkbox 
                        label="Is this the default box set for this subscription product?"
                        hide-details
                        v-model="set.item.default"
                        :disabled="set.item.default"
                        @change="updateBoxSetDefault(set.item)"
                      >
                      </v-checkbox>
                  </v-flex>

                  <v-flex xs12>
                    <v-card class="elevation-2 mt-3">
                    <v-toolbar dense>
                      <v-toolbar-title>Months</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-tooltip left>
                        <v-btn slot="activator" @click="addBoxSetMonth(set.item)" small icon>
                          <v-icon>add</v-icon>
                        </v-btn>
                        <span>
                        Add Month
                        </span>
                      </v-tooltip>
                    </v-toolbar>
                    <v-data-table
                      :headers="box_set_month_headers" 
                      :items.sync="set.item.months" 
                      :loading="ui.loading" 
                      item-key="month"
                      class="elevation-0 pa-0 mt-0"
                      hide-actions
                      no-data-text="This month doesn't have any boxes in it yet."
                    >
                      <template slot="items" slot-scope="set_months">
                        <tr @click="set_months.expanded = !set_months.expanded" class="pointer" :class="{'box-card-toolbar': set_months.expanded}">
                            <td class="font-weight-bold">{{set_months.item.month}}</td>
                            <td>{{set_months.item.amount}}</td>
                        </tr>
                      </template>
                      <template slot="expand" slot-scope="set_month">
                        <v-flex xs12 class="elevation-1">
                        <v-select
                          class="ml-2 mr-2"
                          v-model="set_month.item.boxes"
                          :items="props.item.boxes.map((box) => { 
                            box.subscription_box_id = box.id
                            return box
                          })"
                          item-text="subscription_box_id"
                          item-value="subscription_box_id"
                          return-object
                          chips
                          label="Boxes"
                          multiple
                          dense
                          hide-details
                          @change="saveBoxSet(set.item)"
                        >
                          <template slot="selection" slot-scope="data">
                            <v-chip small>
                              {{ data.item.description }} &nbsp; &middot; &nbsp; <small>{{calculateBoxAvailability(data.item)}} availabile boxes</small>
                            </v-chip>
                          </template>
                          <template slot="item" slot-scope="data">
                           {{ data.item.description }} &nbsp; &middot; &nbsp; <small>{{calculateBoxAvailability(data.item)}} availabile boxes</small>
                          </template>
                        </v-select>
                        </v-flex>
                      </template>
                    </v-data-table>
                    </v-card>

<!--
                  <v-list two-line subheader>
                    <v-subheader class="white--text elevation-4" :class="{'primary': !isDark, 'grey darken-4': isDark}"><h2>Months</h2>
                      <v-spacer></v-spacer>
                      <v-tooltip left>
                      <v-btn slot="activator" @click="addBoxSetMonth(set.item)" small icon>
                        <v-icon class="white--text">add</v-icon>
                      </v-btn>
                      <span>
                      Add Month
                      </span>
                      </v-tooltip>
                    </v-subheader>
                    <v-card class="elevation-4">
                    <template v-for="(box, box_index) in set.item.boxes">
                      <v-list-tile
                        :key="box_index"
                        avatar
                        ripple
                        class="list-pointer"
                      >
                        <v-list-tile-content>
                          <v-select
                              :items="props.item.boxes"
                              v-model="box.subscription_box_id"
                              @change="saveBoxSet(set.item)"
                              item-text="description"
                              item-value="id"
                              hide-details
                              single-line
                              label="Choose a box"
                              class="mt-2"
                            >
                              <template slot="item" slot-scope="data">
                                {{ data.item.description }} &nbsp; &middot; &nbsp; <small>{{calculateTotalItems(data.item.line_items)}} items</small>
                              </template>
                            </v-select>
                        </v-list-tile-content>

                        <v-list-tile-action>
                          <v-list-tile-action-text>Month {{ box_index + 1}}</v-list-tile-action-text>
                          <v-icon v-if="box.month === 1">
                            check
                          </v-icon>
                        </v-list-tile-action>

                      </v-list-tile>
                      <v-divider
                        v-if="box_index + 1 < set.item.boxes.length"
                        :key="box_index + '-divider'"
                      ></v-divider>
                    </template>
                    </v-card>
                  </v-list>
                  -->
                  </v-flex>
                  </v-layout>
                  </v-container>
              </template>
              </v-data-table>


                  </v-card-texT>
                </v-card>
              </v-tab-item>
            </v-tabs>

            </v-flex>
            </v-layout>
        </template>
        
    </v-data-table>

</v-card>

<v-dialog v-model="ui.warning" persistent max-width="290">
  <v-card class="error">
    <v-card-title class="headline">No!</v-card-title>
    <v-card-text>{{ui.warning_message}}</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click.native="ui.warning = false">Alright</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

</v-layout>
</template>

<script>
import { db } from '@/services/firebase.js'
import { isUndefined, clone } from 'lodash'

export default {
    data () {
        return {
          stepper: 1,
            ui: {
                tab: null,
                loading: true,
                dialog: false,
                new_box: '',
                warning: false,
                warning_message: ''
            },
            subscription_product_headers: [
                { text: 'Product Variant', value: 'title'},
                { text: 'SKU', value: 'sku' },
                { text: 'Boxes', value: 'boxes' },
                { text: 'Box Sets', value: 'sets' },
                { text: '', value: '', align: 'right', width: 100}
            ],
            subscription_product_variant_headers: [
                { text: 'Box Description', value: 'description'},
                { text: 'Items', width: 100,  value: 'line_items' },
                { text: 'Weight', width: 100, value: 'weight' },
                { text: 'Worth', width: 100, value: 'worth' },
                { text: 'Default', width: 50, align: 'right', value: 'default' }
            ], 
            box_set_headers: [
                { text: 'Set Description', value: 'description'},
                { text: 'Months', width: 100,  value: 'months' },
                { text: 'Default', width: 50, align: 'right', value: 'default' }
            ],
            box_set_month_headers: [
                { text: 'Month', value: 'month', sortable: false },
                { text: 'Boxes', width: 100,  value: 'boxes', sortable: false }
            ],
            box_headers: [
                { text: 'Name', value: 'title'},
                { text: 'SKU', value: 'sku' },
                { text: 'Weight', value: 'weight' },
                { text: 'Price', value: 'price' },
                { text: 'Inventory', value: 'inventory_quantity'},
                { text: 'Quantity', align: 'center', value: 'quantity' },
                { text: 'Remove', value: '', width:20}
            ],         
            product_headers: [
                { text: '', value: '', sortable: false, width:20},
                { text: 'Name', value: 'title'},
                { text: 'Product Type', value: 'product_type'},
                { text: 'Variants', value: 'variants' }
            ],
            variant_headers: [
                { text: 'Variant', value: 'title'},
                { text: 'SKU', value: 'sku' },
                { text: 'Weight', value: 'weight' },
                { text: 'Inventory', value: 'inventory_quantity'},
                { text: 'Price', value: 'price' },
                { text: 'Add', value: '', width:20 }
                
            ],
            box: { product: {} },
            boxes: [],
            box_sets: [],
            products: [],
            productSearch: ''
        }
    },
    filters: {

    },
    computed: {
        isAdmin () {
          return this.$store.getters.isAdmin !== null && this.$store.getters.isAdmin !== undefined
        },
        isManager () {
          return this.$store.getters.isManager !== null && this.$store.getters.isManager !== undefined
        },
        isDark: function () {
            return this.$vuetify.dark
        },
        subscriptionProducts () {
          var self = this
          var subscription_products = []
          var subscription_boxes = []
          var unassigned_subscription_boxes = []

          self.products.forEach((product) => {
            if(product.product_type === 'subscription'){
              subscription_products.push(product)
            }
          })
          
          subscription_products.forEach((subscription_product) => {      
            var product = {
              expand: false,
              product: subscription_product,
              variants: []
            }
            subscription_product.variants.forEach((subscription_product_variant) => {
              var variant = {
                expand: false,
                id: subscription_product_variant.id,
                subscription_product_id: subscription_product.id,
                title: subscription_product_variant.title,
                sku: subscription_product_variant.sku,
                boxes: self.boxes.filter((box) => {
                  return box.subscription_product_variant_id === subscription_product_variant.id
                }),
                box_sets: self.box_sets.filter((box_set) => {
                  return box_set.subscription_product_variant_id === subscription_product_variant.id
                })
              }
              if (variant.box_sets.length > 0) {
                variant.box_sets.forEach((variant_box_set) => {
                  if (Array.isArray(variant_box_set.months) === false) {
                    variant_box_set.months = self.boxSetMonthsToArray(variant_box_set.months, variant_box_set.id)
                  }
                })
              }
              product.variants.push(variant)
            })
            subscription_boxes.push(product)
          })
          return {assigned: subscription_boxes, unassigned: unassigned_subscription_boxes}
        },
        allSubscriptionProducts () {
          var self = this
          var subscription_products = []

          self.products.forEach((product) => {
            if(product.product_type === 'subscription'){
              subscription_products.push(product)
            }
          })
          console.log(subscription_products)
          return subscription_products
        }
    },
    methods: {
      calculateTotalItems: function(items) {
        var total_items = 0
        items.forEach((item) => {
          total_items = total_items + parseInt(item.quantity)
        })
        return total_items
      },
      calculateWeight: function (items) {
        var weight = 0
        items.forEach((item) => {
          weight = weight + (item.weight * item.quantity)
        })
        return weight
      },
      calculateWorth: function (items) {
        var worth = 0
        items.forEach((item) => {
          worth = worth + (parseFloat(item.price) * item.quantity)
        })
        return worth.toFixed(2)
      },
      openBox: function(product, box) {
        var self = this
        self.box = box
        self.ui.dialog = true
      },
      createBox: function(subscription_product, variant_index, variant) {
        var self = this
        var box = {
          id: Date.now(),
          subscription_product_id: subscription_product.product.id,
          subscription_product_variant_id: variant.id,
          line_items: [],
          default: false,
          description: 'New box'
        }
        if(variant.boxes.length === 0){
          box.default = true
        }
        self.boxes.push(box)
        db.collection('boxes').doc(box.id.toString()).set(box)
        self.$root.$emit('event', {type: 'info', event: 'Created new subscription box for: ' + variant.sku})
      },
      deleteBox: function(subscription_box, variant) {
        var self = this
        if(!subscription_box.default){
          /*
          var box_index = self.boxes.findIndex((b) => {
            return b.id === subscription_box.id
          })
          self.boxes.splice(box_index, 1)
          */
          db.collection('boxes').doc(subscription_box.id.toString()).delete()
          self.$root.$emit('event', {type: 'info', event: 'Deleted subscription box for: ' + variant.sku})
        } else {
          self.ui.warning_message = 'You are not allowed to delete the default box for a subscription product. Choose a new default box before proceeding.'
          self.ui.warning = true
        }
      },
      saveBox: function(subscription_box) {
        var self = this
        var box_index = self.boxes.findIndex((b) => {
          return b.id === subscription_box.id
        })
        db.collection('boxes').doc(subscription_box.id.toString()).update(self.boxes[box_index])
      },
      addItemToBox: function(subscription_product, subscription_box, item) {
        var self = this
        var box_index = self.boxes.findIndex((b) => {
          return b.id === subscription_box.id
        })
        var item_product = self.products.find((p) => {
          return p.id === item.product_id
        })
        var box_exists = subscription_box.line_items.findIndex((p) => {
          return p.product_id === item.product_id
        })

        item.title = item_product.title

        if(box_exists !== -1){
          var box_line_item_index = self.boxes[box_index].line_items.findIndex((p) => {
            return p.id === item.id
          })
          self.boxes[box_index].line_items[box_line_item_index].quantity++
        } else {
          item.quantity = 1
          self.boxes[box_index].line_items.push(item)
        }
        db.collection('boxes').doc(subscription_box.id.toString()).update(self.boxes[box_index])
        self.$forceUpdate()
      },
      removeItemFromBox: function(subscription_product, subscription_box, item) {
        var self = this
        var box_index = self.boxes.findIndex(b => b.id === subscription_box.id)
        var item_index = subscription_box.line_items.findIndex(b => b.id === item.id)
        self.boxes[box_index].line_items.splice(item_index, 1)
        db.collection('boxes').doc(subscription_box.id.toString()).update(self.boxes[box_index])
      },
      updateItemQuantity: function(subscription_product, subscription_box, item, action){
        var self = this
        var box_index = self.boxes.findIndex((b) => {
          return b.id === subscription_box.id
        })
        /*
        var item_index = self.boxes.findIndex((b) => {
          return b.id === item.id
        })
        */
        var box_exists = subscription_box.line_items.findIndex((p) => {
          return p.product_id === item.product_id
        })
        if(box_exists !== -1){
          var box_line_item_index = self.boxes[box_index].line_items.findIndex((p) => {
            return p.id === item.id
          })
          if(action === 'add'){
            self.boxes[box_index].line_items[box_line_item_index].quantity++
            db.collection('boxes').doc(subscription_box.id.toString()).update(self.boxes[box_index])
          }
          if(action === 'remove'){
            if((self.boxes[box_index].line_items[box_line_item_index].quantity - 1) >= 1){
              self.boxes[box_index].line_items[box_line_item_index].quantity--
              db.collection('boxes').doc(subscription_box.id.toString()).update(self.boxes[box_index])
            }
          }
          self.$forceUpdate()
        }
      },
      updateBoxDefault: function(subscription_product, subscription_box) {
        var self = this

        var new_box_index = self.boxes.findIndex((b) => {
          return b.id === subscription_box.id
        })

        var variant_index = subscription_product.variants.findIndex((v) => {
          return v.id === subscription_box.subscription_product_variant_id
        })

        var old_default = subscription_product.variants[variant_index].boxes.findIndex((b) => {
          return b.default === true && b.id !== subscription_box.id
        })
        var old_box_index = self.boxes.findIndex((b) => {
          return b.id === subscription_product.variants[variant_index].boxes[old_default].id
        })
        self.boxes[old_box_index].default = false
        
        db.collection('boxes').doc(subscription_product.variants[variant_index].boxes[old_default].id.toString()).update(self.boxes[old_box_index])
        db.collection('boxes').doc(subscription_box.id.toString()).update(self.boxes[new_box_index])
      },
      createBoxSet: function(subscription_product_variant) {
        var self = this

        var box_set = {
          description: 'New Box Set',
          default: false,
          subscription_product_id: subscription_product_variant.subscription_product_id,
          subscription_product_variant_id: subscription_product_variant.id,
          boxes: [],
          months: {},
          created_at: Date.now(),
          id: Date.now()
        }
        var box = {
          subscription_box_id: null
        }
        var subscription_box = subscription_product_variant.boxes.find((subscription_product_variant_box) => {
          return subscription_product_variant_box.default === true
        })
        box.subscription_box_id = subscription_box.id
        box_set.boxes.push(box)

        box_set.months['1'] = [box]

        var default_exists_for_variant = self.box_sets.find((sets) => {
          return (sets.subscription_product_variant_id === subscription_product_variant.id && sets.default === true)
        })

        if (isUndefined(default_exists_for_variant)) {
          box_set.default = true
        }

        db.collection('box-sets').doc(box_set.id.toString()).set(box_set)
        self.$root.$emit('event', {type: 'info', event: 'Created box set for: ' + box_set.subscription_product_variant_id})
      },
      addBoxSetMonth: function(box_set) {
        var self = this
        box_set = clone(box_set, true)
        /*
        var set = {
          month: box_set.boxes.length + 1,
          subscription_product_id: box_set.subscription_product_id,
          subscription_product_variant_id: box_set.subscription_product_variant_id,
          subscription_box_id: null,
          created_at: Date.now(),
          boxes: [],
          id: Date.now()
        }
        box_set.boxes.push(set)
        */
        var default_box = self.boxes.find((box) => {
          return ((box.default === true) && (box.subscription_product_variant_id === box_set.subscription_product_variant_id))
        })

        var month_first_box = { subscription_box_id: default_box.id }

        box_set.months.push({ month: box_set.months.length + 1, boxes: [month_first_box] })

        self.saveBoxSet(box_set)
      },
      deleteBoxSet: function(box_set) {
        var self = this
        if (box_set.default === false) {
          db.collection('box-sets').doc(box_set.id.toString()).delete()
          self.$root.$emit('event', {type: 'info', event: 'Deleted box set for: ' + box_set.subscription_product_variant_id})
        } else {
          self.ui.warning_message = 'You can not delete a default box set. Choose a new default box set before proceeding.'
          self.ui.warning = true
        }
      },
      saveBoxSet: function(box_set) {
        var self = this
        // we need to wait for the model to update first so we have the changes available to us
        self.$nextTick(() => {
          var months = {}
          var monthIsEmpty = false
          box_set.months.forEach((month) => {
            months[month.month] = month.boxes.map((box) => {
              return { subscription_box_id: box.subscription_box_id }
            })
            if (months[month.month].length === 0) monthIsEmpty = true
          })
          box_set.months = months
          // we won't allow a box set to be saved if a month is empty within it
          if (!monthIsEmpty) {
            db.collection('box-sets').doc(box_set.id.toString()).set(box_set)
          } else {
            self.ui.warning_message = "The changes to this box set were not saved because a month within it can not be left empty. Make sure at least one box is selected for each month."
            self.ui.warning = true
          }
        })
      },
      updateBoxSetDefault: function(box_set) {
        var self = this
        var previous_default = self.box_sets.find((previous_box_set) => {
          return previous_box_set.default === true && previous_box_set.id !== box_set.id
        })
        if(!isUndefined(previous_default)){
          db.collection('box-sets').doc(previous_default.id.toString()).update({default: false})
        }
        db.collection('box-sets').doc(box_set.id.toString()).update({default: true})
      },
      boxSetMonthsToArray: function(box_set_months, box_set_id) {
        var self = this
        var months = []
        if (Object.keys(box_set_months).length > 0) {
          Object.keys(box_set_months).forEach((month) => {
            box_set_months[month].forEach((box) => {
              box.box = self.boxes.find(boxes => boxes.id === box.subscription_box_id)
              box.subscription_box_id = box.subscription_box_id
              box.availability = self.calculateBoxAvailability(box.box)
              box.box_set_id = box_set_id
            })
            months.push({month: month, amount: box_set_months[month].length, boxes: box_set_months[month]})
          })
        }
        return months
      },
      calculateBoxAvailability: function (box) {
        var self = this
        var product_inventories = []
        box.line_items.forEach((item) => {
          var product = self.products.find(product => product.id === item.product_id)
          var variant = product.variants.find(v => v.id === item.id)
          product_inventories.push(variant.inventory_quantity)
        })
        return Math.min(...product_inventories)        
      },
      getVariantInventory: function (product_id, sku) {
        var self = this
        var product = self.products.find(p => p.id === product_id)
        var variant = product.variants.find((v) => {
            return v.sku === sku
        })

        if (!isUndefined(variant)) {
            return variant.inventory_quantity
        } else {
            return 0
        }
      }
    },
    created () {
        var self = this
        db.collection('boxes').onSnapshot(boxesSnapshot => {
          var boxes = []
          boxesSnapshot.forEach(function(doc) {
              boxes.push(doc.data())
          })
          self.boxes = boxes
          self.ui.loading = false
        })
        
        db.collection('box-sets').onSnapshot(boxSetSnapshot => {
          var box_sets = []
          boxSetSnapshot.forEach(function(doc) {
              box_sets.push(doc.data())
          })
          self.box_sets = box_sets
          self.ui.loading = false
        })
        
        db.collection('products').onSnapshot(productsSnapshot => {
          var products = []
          productsSnapshot.forEach(function(doc) {
              products.push(doc.data())
          })
          self.products = products
          self.ui.loading = false
        })
    },
    mounted () {

    }
}
</script>

<style lang="stylus" scoped>
.box-card-toolbar, .box-card-background
  background-color #212121!important
.list-pointer
  cursor pointer
  transition all 0.75 ease
.error
  color #FFFFFF!important
  .v-btn
    color #FFFFFF!important
.application .theme--dark-old .v-card, .theme--dark-old .v-card
  background-color #40525b!important
  .box-card-toolbar-old
    background-color #0D2029!important
  .box-card-background-old
    background-color #1d2935!important
.theme--dark-old .v-card
  background #0D2029!important
  background-color #0D2029!important
.no-hover.v-btn.v-btn--icon.v-btn--small::before
  opacity: 0!important
.theme--dark-old .variant-table table
  background #0D2029!important
  background-color #0D2029!important
  font-size 20px!important
.application .theme--light .v-card, .theme--light .v-card
  .box-card-toolbar
    background-color #1976d2!important
    color #FFFFFF!important
    font-weight 500!important
  .box-card-background
    background-color #FFFFFF!important
    color #FFFFFF!important
  .box-card-icon
    background-color transparent!important
    color #FFFFFF!important
</style>